// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YOp93","image":"styles_image__1idVE","title":"styles_title__27_CG","description":"styles_description__2hSaP","input":"styles_input__3TjoI"};